import { PillarPage } from "@/components/PillarPage";

export const POC_SETUP_META = {
  title: "Por que POC e setup? Custo total do CRM com IA para corretoras de seguros",
  description:
    "Entenda o custo total da OP2P para corretoras de seguros: mensalidade, setup de implantação, POC de 7 dias configurada, passagem para atendimento humano e API oficial do WhatsApp.",
};

export default function PorQuePocESetup() {
  return (
    <PillarPage
      slug="por-que-poc-e-setup"
      metaTitle={POC_SETUP_META.title}
      metaDescription={POC_SETUP_META.description}
      h1="Por que POC e setup: o custo real de um CRM com Agentes de IA para corretoras de seguros"
      lead="Corretora de seguros não pode errar cotação, perder renovação nem arriscar o número de WhatsApp. Por isso a OP2P não oferece teste grátis genérico: entregamos uma POC de 7 dias já configurada com a sua operação, com custo total claro desde o primeiro contato."
      answer="O custo total da OP2P é a mensalidade do plano (com CRM incluso) mais um setup único de implantação, ambos apresentados em proposta personalizada na reunião de demonstração. O setup paga a construção da operação: funil de cotações e renovações, base de conhecimento dos Agentes de IA, integrações e testes. Antes de decidir, a corretora valida tudo em uma POC de 7 dias configurada com seus produtos. Os Agentes de IA passam a conversa para um corretor humano sempre que necessário, e o atendimento roda pela API oficial do WhatsApp Business, sem risco de gambiarras de QR Code."
      sections={[
        {
          h2: "Custo total: o que você paga e o que está incluso",
          table: {
            head: ["Item", "Como funciona", "Quando"],
            rows: [
              ["Mensalidade", "Inclui CRM, Agentes de IA, WhatsApp e Instagram; valor apresentado na reunião", "Mensal"],
              ["Setup de implantação", "Valor único conforme o escopo, apresentado na reunião", "Uma vez"],
              ["POC de 7 dias", "Operação configurada para validar com seus leads reais", "Antes da decisão"],
              ["Conversas no WhatsApp", "Cobradas pela Meta conforme a tabela oficial da API, quando aplicável", "Conforme uso"],
            ],
          },
          paragraphs: [
            "Sem custo escondido de desenvolvedor, servidor ou consultoria paralela: a equipe da OP2P cuida da implantação. Valores, setup e cronograma da POC de 7 dias são apresentados na reunião de demonstração.",
          ],
        },
        {
          h2: "Por que existe o setup",
          paragraphs: [
            "A maioria das corretoras já contratou um CRM e parou de alimentar, porque ele chegou vazio e difícil de configurar. O setup resolve exatamente isso: você recebe o CRM pronto e alimentado pelos Agentes de IA.",
          ],
          bullets: [
            "Funil por ramo: seguro auto, vida, plano de saúde, residencial e empresarial",
            "Perguntas de cotação que os Agentes de IA coletam (idade, CEP, veículo, vidas, operadora atual)",
            "Base de conhecimento com seus produtos, seguradoras parceiras e regras da corretora",
            "Rotinas de follow-up de propostas e alertas de renovação",
            "Integrações com as ferramentas que a corretora já usa",
          ],
        },
        {
          h2: "POC de 7 dias: validação, não teste grátis",
          paragraphs: [
            "Um teste grátis genérico entrega um sistema vazio e deixa o trabalho com você. A POC da OP2P é diferente: em 7 dias a operação roda configurada para a sua corretora, com conversas reais, e você avalia velocidade de resposta, qualidade da qualificação e leads entrando no funil.",
          ],
          bullets: [
            "Agentes de IA treinados nos seus produtos de seguro",
            "Funil de cotações montado no CRM",
            "Acompanhamento da equipe OP2P durante a validação",
            "Decisão baseada em resultado observado, não em promessa",
          ],
        },
        {
          h2: "Passagem para atendimento humano",
          paragraphs: [
            "Seguro envolve confiança. Os Agentes de IA atendem 24h, tiram dúvidas e coletam dados, mas o corretor assume sempre que a conversa pede: negociação de proposta, sinistro, reclamação ou quando o cliente pede para falar com uma pessoa.",
          ],
          bullets: [
            "Regras de transferência definidas no setup (palavra-chave, valor, ramo, sentimento)",
            "O corretor recebe o histórico completo no CRM — o cliente não repete nada",
            "Os Agentes de IA voltam a atuar no follow-up quando o humano liberar",
            "Na dúvida, o agente escala em vez de inventar resposta",
          ],
        },
        {
          h2: "WhatsApp oficial: sem risco de bloqueio por gambiarra",
          paragraphs: [
            "Conexões via QR Code não oficiais são uma das principais causas de número banido. A OP2P opera pela API oficial do WhatsApp Business e integra também o Instagram Direct no mesmo CRM, preservando o número que seus clientes já conhecem.",
            "Para a corretora, isso significa carteira protegida, mensagens de renovação dentro das regras da Meta e histórico centralizado do primeiro contato à venda.",
          ],
        },
      ]}
      faq={[
        { q: "A POC de 7 dias é gratuita?", a: "A POC é uma validação configurada para a sua corretora, não um teste grátis genérico. As condições são apresentadas na reunião de demonstração." },
        { q: "O setup é cobrado todo mês?", a: "Não. O setup é um valor único de implantação; depois você paga apenas a mensalidade do plano." },
        { q: "Os Agentes de IA substituem os corretores?", a: "Não. Eles fazem o atendimento inicial, a coleta de dados e o follow-up, e passam para o corretor humano nas etapas de negociação e relacionamento." },
        { q: "Preciso trocar meu número de WhatsApp?", a: "Não. A operação usa a API oficial do WhatsApp Business com o número da corretora." },
        { q: "Funciona para plano de saúde e seguro de vida?", a: "Sim. O funil e as perguntas de cotação são montados por ramo durante o setup." },
      ]}
      related={[
        { label: "CRM para corretora de seguros", to: "/crm-para-corretora-de-seguros" },
        { label: "Agente de IA para seguros", to: "/agente-ia-seguros" },
        { label: "Planos", to: "/precos" },
        { label: "Agendar demonstração", to: "/agenda" },
      ]}
    />
  );
}
